// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ba36aec7","239":"effb64f8","686":"09cf8b80","886":"f3cd7dae","897":"6aa82162","997":"2763d79d"}[chunkId] + ".chunk.js";
};